import React from "react";

import Icon from "./Icon";

type Props = {
    symbol: string;
    className?: string;
};

function ButtonIcon(props: Props) {
    return <Icon symbol={props.symbol} size="lg" className={props.className} />;
}

export default ButtonIcon;
